import { useAppContext } from "../../../Helpers/Contexts/AppContext";
import "./FullBackdrop.css";

export default function FullBackdrop() {
  // App Context
  const [appContext] = useAppContext();

  // Component
  return (
    <div
      id="loader"
      className="loading-overlay"
      style={{
        zIndex: appContext.fullBackdropOpened ? 9999 : -9999,
        transition: "opacity 0.8s ease-in",
        opacity: appContext.fullBackdropOpened ? 1 : 0,
      }}
    >
      <div className="loading-container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <span style={{ color: 'white', fontSize: '24px' }}>Carregando...</span>
        </div>
      </div>
    </div>
  );
}
